import ar from "./lang/ar.json";
import cn from "./lang/cn.json";
import en from "./lang/en.json";
import es from "./lang/es.json";
import hi from "./lang/hi.json";
import hk from "./lang/hk.json";
import id from "./lang/in.json";
import ja from "./lang/ja.json";
import ko from "./lang/ko.json";
import pt from "./lang/pt.json";
import ru from "./lang/ru.json";
import th from "./lang/th.json";
import tr from "./lang/tr.json";
import vi from "./lang/vi.json";
import aiselectAr from "./aiselect/ar.json";
import aiselectCn from "./aiselect/cn.json";
import aiselectEn from "./aiselect/en.json";
import aiselectHk from "./aiselect/hk.json";
import aiselectPt from "./aiselect/pt.json";
import aiselectVi from "./aiselect/vi.json";

/** 合并 aiselect 独立语言包，避免主语言包缓存未更新时 key 无法解析 */
function withAiselect(base, aiselect) {
  return { ...base, ...aiselect };
}

export default {
  "zh-CN": withAiselect(cn, aiselectCn),
  "zh-HK": withAiselect(hk, aiselectHk),
  ar: withAiselect(ar, aiselectAr),
  en: withAiselect(en, aiselectEn),
  es,
  hi,
  id,
  ja,
  ko,
  pt: withAiselect(pt, aiselectPt),
  ru,
  th,
  tr,
  vi: withAiselect(vi, aiselectVi),
};
